import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import {
  SystemVersion,
  ApiResponse,
  CreateSystemVersionRequest,
  UpdateSystemVersionRequest,
} from '@magnetar/admin-api-interfaces'

export const systemVersionService = {
  getAllSystemVersions: async (token: string): Promise<ApiResponse<SystemVersion[]>> => {
    try {
      const response = await apiClient.get<ApiResponse<SystemVersion[]>>('/api/system-versions', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ApiResponse<SystemVersion[]>
      }
      return {
        success: false,
        error: {
          code: 'FETCH_SYSTEM_VERSIONS_FAILED',
          message: '取得系統版本列表失敗',
        },
      }
    }
  },

  getSystemVersionById: async (id: number, token: string): Promise<ApiResponse<SystemVersion>> => {
    try {
      const response = await apiClient.get<ApiResponse<SystemVersion>>(
        `/api/system-versions/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ApiResponse<SystemVersion>
      }
      return {
        success: false,
        error: {
          code: 'FETCH_SYSTEM_VERSION_FAILED',
          message: '取得系統版本失敗',
        },
      }
    }
  },

  createSystemVersion: async (
    data: CreateSystemVersionRequest,
    token: string,
  ): Promise<ApiResponse<SystemVersion>> => {
    try {
      const response = await apiClient.post<ApiResponse<SystemVersion>>(
        '/api/system-versions',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ApiResponse<SystemVersion>
      }
      return {
        success: false,
        error: {
          code: 'CREATE_SYSTEM_VERSION_FAILED',
          message: '建立系統版本失敗',
        },
      }
    }
  },

  updateSystemVersion: async (
    id: number,
    data: UpdateSystemVersionRequest,
    token: string,
  ): Promise<ApiResponse<SystemVersion>> => {
    try {
      const response = await apiClient.put<ApiResponse<SystemVersion>>(
        `/api/system-versions/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ApiResponse<SystemVersion>
      }
      return {
        success: false,
        error: {
          code: 'UPDATE_SYSTEM_VERSION_FAILED',
          message: '更新系統版本失敗',
        },
      }
    }
  },

  deleteSystemVersion: async (id: number, token: string): Promise<ApiResponse<SystemVersion>> => {
    try {
      const response = await apiClient.delete<ApiResponse<SystemVersion>>(
        `/api/system-versions/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ApiResponse<SystemVersion>
      }
      return {
        success: false,
        error: {
          code: 'DELETE_SYSTEM_VERSION_FAILED',
          message: '刪除系統版本失敗',
        },
      }
    }
  },
}
